

import "./allprojects.css";
import { FaGithub } from "react-icons/fa";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AllProjectData } from "./allProjectData";

export const AllProjects = () => {

    const [flag, setFlag] = useState(false);

    const handleshow = () => {
        setFlag(true);
    }

    const handleNoshow = () => {
        setFlag(false);
    }


    const seeGo = (link) => {
        window.open(link, `_blank`);
    }



    return (
        <div className="allprojects_Maindiv">
            <div className={flag === false ? "buttonShow" : "nobuttonShow"}>
                <p>See More Projects</p>
                <div>{flag === false ? <IoIosArrowDown onClick={handleshow} /> : <IoIosArrowUp onClick={handleNoshow} />}</div>
            </div>
            <div className={flag === false ? "noShow" : "allProjects_container"}>

                {

                    AllProjectData.map((el) => {
                        return (
                            <div key={el.id} className="project_con">
                                <div data-aos="flip-right">
                                    <img className="main_img" src={el.img} alt={el.title} />

                                </div>

                                <div data-aos="flip-left" className='details_div'>
                                    <div className="project_heading">
                                        <p>{el.title}</p>

                                    </div>
                                    <div className='project_tech'>
                                        <p>Tech Stacks:</p>
                                        <p>{el.techStack}</p>
                                    </div>
                                    <div className='project_feature'>
                                        <p>Features:</p>
                                        <p>{el.feature}</p>
                                    </div>
                                    <div className="link_div">
                                        <FaGithub onClick={() => seeGo(`${el.git}`)} className="gitLogo" />
                                        <BsBoxArrowUpRight onClick={() => seeGo(`${el.visit}`)} className="gitLogo" />
                                    </div>
                                </div>
                            </div>

                        )
                    })

                }






            </div>
        </div>
    )
}